/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

export const DATE_FORMATS = {
    DATE: 'dd, DD.MM.YYYY',
    DATE_YMD: 'YYYY-MM-DD',
    /** Backend table search date ranges (from/to). */
    DATE_DMY: 'DD.MM.YYYY',
    TIME: 'HH:mm',
    DATE_TIME: 'dd, DD.MM.YYYY HH:mm',
	DATE_TIME_SEC: 'dd, DD.MM.YYYY HH:mm:ss',
    DATE_DOT: 'dd, DD.MM.YYYY',
    DATE_TIME_DOT: 'dd, DD.MM.YYYY HH:mm',
    DATE_TIME_DAY: 'dd, DD.MM.YYYY HH:mm',
} as const
